// extracted by mini-css-extract-plugin
export default {"wrapper":"wE-z","button":"xE-z","alternate":"yE-z","disabled":"zE-z","paymentWarning":"AE-z","fadeIn":"BE-z"};